module.exports = __webpack_public_path__ + "26c0325921657d903102f652220490b3.ttf";